/* Staciny catalog: hearts save necklaces on this device; the "Saved" chip shows only those.
   Saved handles live in localStorage under "stc-saved" (shared with any other page that shows hearts). */
(function () {
  'use strict';
  var KEY = 'stc-saved';
  function read() { try { return JSON.parse(localStorage.getItem(KEY)) || []; } catch (e) { return []; } }
  function write(list) { try { localStorage.setItem(KEY, JSON.stringify(list)); } catch (e) { /* private mode */ } }

  function init(root) {
    if (!root || root.hasAttribute('data-ready')) return;
    root.setAttribute('data-ready', '');
    var chip = root.querySelector('[data-stc-saved-filter]');
    var countEl = root.querySelector('[data-stc-saved-count]');
    var total = root.querySelector('[data-stc-count]');
    var none = root.querySelector('[data-stc-none]');
    var tiles = Array.prototype.slice.call(root.querySelectorAll('[data-handle]'));
    var totalText = total ? total.textContent : '';
    var filtering = false;

    function paint() {
      var saved = read();
      root.querySelectorAll('[data-stc-fav]').forEach(function (b) {
        var on = saved.indexOf(b.getAttribute('data-stc-fav')) > -1;
        b.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
      if (chip) {
        chip.hidden = saved.length === 0 && !filtering;
        countEl.textContent = saved.length;
      }
      var shown = 0;
      tiles.forEach(function (t) {
        var hide = filtering && saved.indexOf(t.getAttribute('data-handle')) === -1;
        t.hidden = hide;
        if (!hide) { shown++; t.classList.add('is-in'); }
      });
      if (none) none.hidden = !(filtering && shown === 0);
      if (total) total.textContent = filtering ? shown + ' saved' : totalText;
    }

    root.addEventListener('click', function (e) {
      var b = e.target.closest('[data-stc-fav]');
      if (!b) return;
      e.preventDefault();
      var h = b.getAttribute('data-stc-fav');
      var saved = read();
      var i = saved.indexOf(h);
      if (i > -1) saved.splice(i, 1); else { saved.push(h); b.classList.remove('is-pop'); void b.offsetWidth; b.classList.add('is-pop'); }
      write(saved);
      paint();
    });
    if (chip) {
      chip.addEventListener('click', function () {
        filtering = !filtering;
        chip.setAttribute('aria-pressed', filtering ? 'true' : 'false');
        paint();
      });
    }
    paint();
  }

  function boot() { document.querySelectorAll('[data-stc-cat]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
